import { createFileRoute } from "@tanstack/react-router";
import { CalendarCheck, NotebookPen, Video } from "lucide-react";
import { useOnceDataLayerEvent } from "@/lib/datalayer";
import { Layout } from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { ProzessTimeline } from "@/components/buergermeisterwahl/ProzessTimeline";
import { CasesSection } from "@/components/cases/CasesSection";

export const Route = createFileRoute("/termin/danke-email")({
  head: () => ({
    meta: [
      { title: "Vielen Dank für Ihre Nachricht | creategy" },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content:
          "Vielen Dank für Ihre Rückmeldung per E-Mail. Wir melden uns an Werktagen innerhalb von 24 Stunden persönlich bei Ihnen.",
      },
      { property: "og:title", content: "Vielen Dank für Ihre Nachricht | creategy" },
      {
        property: "og:description",
        content:
          "Vielen Dank für Ihre Rückmeldung per E-Mail. Wir melden uns an Werktagen innerhalb von 24 Stunden persönlich bei Ihnen.",
      },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://creategy.de/termin/danke-email" }],
  }),
  component: TerminDankeEmailPage,
});

const STEPS = [
  { title: "Nachricht eingegangen", text: "Ihre Rückmeldung liegt uns vor und wird direkt dem richtigen Ansprechpartner zugeordnet.", Icon: CalendarCheck },
  { title: "Terminabstimmung", text: "Wir schlagen Ihnen per E-Mail einen passenden Termin vor.", Icon: NotebookPen },
  { title: "Ihr Erstgespräch", text: "Simon Mai nimmt sich Zeit für Ihre Ausgangslage und zeigt Ihnen, welche nächsten Schritte sinnvoll sind. Kostenlos und unverbindlich.", Icon: Video },
];

function TerminDankeEmailPage() {
  useOnceDataLayerEvent({ event: "terminbuchung_email" });
  return (
    <Layout>
      {/* Sektion 1: Hero */}
      <section>
        <div className="section-y mx-auto w-full max-w-[1400px] px-6 md:px-12">
          <h1 className="heading-h1 text-primary">
            Vielen Dank für Ihre Rückmeldung.
          </h1>
          <p className="mt-8 max-w-2xl font-body text-base leading-relaxed text-foreground md:text-lg">
            Ihre Nachricht ist bei uns eingegangen. Wir melden uns an Werktagen innerhalb von 24 Stunden persönlich bei Ihnen, um einen Termin mit Ihnen abzustimmen.
          </p>
        </div>
      </section>

      {/* Sektion 2: Prozess */}
      <section aria-labelledby="termin-danke-email-prozess">
        <div className="section-y mx-auto w-full max-w-[1400px] px-6 md:px-12">
          <Reveal>
            <h2 id="termin-danke-email-prozess" className="heading-h2 text-primary">
              So geht es weiter.
            </h2>
          </Reveal>
          <div className="mt-16 md:mt-20">
            <ProzessTimeline headingColor="text-primary" steps={STEPS} />
          </div>
        </div>
      </section>

      {/* Sektion 3: Cases */}
      <CasesSection
        includeTags={["buergermeisterwahl", "direktkandidaten"]}
        title={"Cases &\u00a0Referenzen"}
        description="Ein Auszug aus Projekten, die einem Erstgespräch wie Ihrem folgten."
        headingColor="text-primary"
      />
    </Layout>
  );
}
